import React, {useRef} from 'react';
import {useDrag, useDrop} from 'react-dnd';
import {GridRow, GridRowProps, RowPropsOverrides} from '@mui/x-data-grid';
import {FileData} from 'types';
import classNames from 'classnames';

const ItemTypes = {
   ROW: 'row',
};

type Props = GridRowProps &
   RowPropsOverrides & {
      moveRow: (to: string, from: FileData) => void;
   };

export const DraggableRow = (props: Props) => {
   const {row: _row, index, moveRow, ...rest} = props;
   const row = _row as FileData;
   const ref = useRef<HTMLDivElement>(null);

   const [{canDrop, isOver}, drop] = useDrop({
      accept: ItemTypes.ROW,
      canDrop: (item: FileData) => row.type === 'folder' && row.name !== item.name,
      drop: (item: any, monitor) => {
         if (!ref.current) return;

         if (row.name === item.name) return;

         moveRow(row.path, item);

         //  item.index = hoverIndex;
      },
      collect: (monitor) => ({
         isOver: !!monitor.isOver(),
         canDrop: !!monitor.canDrop(),
      }),
   });

   const [{isDragging}, drag] = useDrag({
      type: ItemTypes.ROW,
      item: row, //{id: row.id, index},
      collect: (monitor) => ({
         isDragging: monitor.isDragging(),
      }),
   });

   drag(drop(ref));

   return (
      <div
         ref={ref}
         style={{opacity: isDragging ? 0.5 : 1}}
         className={classNames({
            'dnd-droppable': canDrop,
            'dnd-highlighted': isOver,
         })}
      >
         <GridRow {...rest} row={row} index={index} />
      </div>
   );
};
